export default {"src":"/_next/static/media/whatsapp.9ca5fb4b.svg","height":601,"width":601,"blurWidth":0,"blurHeight":0};